import React, { useContext, useMemo } from 'react';
import { TVisningstyp } from '../BusinessDataSet/BusinessDataSet';
import { RutinSettingsContext } from '../../RutinAvailabilityContext/RutinAvailabilityContext';
import { getVisningsTyp } from '../../../../Utils/VisningsUtils';
import { rutinKeys } from '../../../Const/RutinInfo';
import { ActiveRoutineContext } from '../../../../../Routing/ActiveRoutine/ActiveRoutineContext';
import { useWidth } from '../../../../../../Components/BreakpointContext/BreakpointContextUtils';

export interface IVisningsTypContext {
  visningsTyp: TVisningstyp;
  setVisningsTyp: (value: TVisningstyp) => void;
  rutinId: number;
  showDetailsRight?: boolean;
  setShowDetailsRight?: (value: boolean) => void;
}

interface IProps {
  rutinID: number;
  collectionName: string;
  inCard?: boolean;
  showDetailsRight?: boolean;
  setShowDetailsRight?: (value: boolean) => void;
  /**Om visningstypen avser innehållslistan i en rutin */
  isRutin?: boolean;
  /**Om visningstypen inte avser innehållslistan i en rutin så kan man ange defaultvärde för visningstypen direkt */
  defaultVisningstyp?: TVisningstyp;
}

export const VisningsTypContext = React.createContext<IVisningsTypContext>({
  visningsTyp: 'lista',
  setVisningsTyp: () => {},
  rutinId: 0,
});

export const useVisningstypContext = (): IVisningsTypContext =>
  useContext(VisningsTypContext);

export const VisningsTypContextProvider: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const rutinAvailabilityContext = useContext(RutinSettingsContext);
  const activeRoutineContext = useContext(ActiveRoutineContext);

  const screenWidth = useWidth();

  const selectedLayoutVisningstyp =
    activeRoutineContext?.selectedLayout?.visningstyp;

  const value = useMemo<IVisningsTypContext>(
    () => ({
      visningsTyp: getVisningsTyp(
        rutinAvailabilityContext,
        props.rutinID,
        props.collectionName,
        screenWidth,
        Boolean(props.inCard),
        rutinKeys[props.rutinID],
        props.isRutin ? selectedLayoutVisningstyp : props.defaultVisningstyp
      ),
      setVisningsTyp: rutinAvailabilityContext.setVisningsTyp(
        props.rutinID,
        props.collectionName
      ),
      rutinId: props.rutinID,
      setShowDetailsRight: props.setShowDetailsRight,
      showDetailsRight: props.showDetailsRight,
    }),
    [
      rutinAvailabilityContext,
      props.rutinID,
      props.collectionName,
      props.inCard,
      props.isRutin,
      props.defaultVisningstyp,
      props.setShowDetailsRight,
      props.showDetailsRight,
      screenWidth,
      selectedLayoutVisningstyp,
    ]
  );

  return (
    <VisningsTypContext.Provider value={value}>
      {props.children}
    </VisningsTypContext.Provider>
  );
};
